import { normalizeColorName, toCamelCase } from 'utils/string';

export default {
  map(options: any) {
    const { settings, publishSettings, manifest, translations, publishMode } = options;
    return {
      template: mapTemplateSettings(settings),
      publish: publishSettings,
      manifest,
      translations,
      publishMode
    };
  }
};

function mapTemplateSettings(settings: any) {
  return {
    fonts: mapFonts(settings.fonts),
    branding: {
      mainLogo: settings.branding.logo.url,
      alternativeLogo: settings.branding.alternativeLogo.url,
      allowToShowMainLogo: settings.branding.logo.allowToShowLogo,
      colors: mapColors(settings.branding.colors)
    },
    background: settings.branding.background,
    languages: settings.languages,
    saveProgressCrossDevice: settings.saveProgressCrossDevice,
    loginViaSocialMedia: settings.loginViaSocialMedia,
    conductLearnerSatisfactionSurvey: settings.conductLearnerSatisfactionSurvey,
    allowUsersToDownloadCertificates: settings.allowUsersToDownloadCertificates,
    resultsTracking: settings.resultsTracking,
    allowUserToSkipTrackingAndTracing: settings.allowUserToSkipTrackingAndTracing,
    allowScoringOfContentPages: settings.allowScoringOfContentPages,
    masteryScore: settings.masteryScore,
    xApi: settings.xApi
  };
}

function mapFonts(fonts: any) {
  return fonts.reduce((acc: any, item: any) => {
    acc[toCamelCase(item.key)] = item;
    return acc;
  }, {});
}

function mapColors(colors: any) {
  return colors.reduce((acc: any, item: any) => {
    acc[normalizeColorName(item.key)] = item.value;
    return acc;
  }, {});
}
